import React, { useEffect, useState } from 'react';
import styles from './component.module.css';
import { Tooltip } from 'antd';

const ProgressBar = ({ connectorStatus, bookingStatus, startTime, endTimeWithGrace, energyReport, timeFormatAmPm, endTimeScheduled, gracePeriod, isNightCharging, bookingEndTime }) => {

  const endTime = new Date(endTimeWithGrace);
  // console.log("endTime", endTime);
  // console.log(new Date(endTimeWithGrace) - new Date(startTime))
  // console.log("grace period", gracePeriod);
  endTime.setMinutes(endTime.getMinutes() - gracePeriod);
// console.log("endTime in progress bar", endTime);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isFinished, setIsFinished] = useState(false);

  const [gracePeriodPercentage, setGracePeriodPercentage] = useState(100);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      if (now.getMinutes() !== currentTime.getMinutes()) {
        setCurrentTime(now);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [currentTime]);


  const formattedStartTime = startTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });
  const formattedEndTime = isNightCharging ? new Date(bookingEndTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm }) : endTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });
  const formattedEndTimeWithGrace = endTimeWithGrace.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });



  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const currentDate = new Date();
    const dateToConvert = new Date(dateString);

    date.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const options = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: timeFormatAmPm
    };

    let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);

    if (date.getTime() > currentDate.getTime()) {
      updatedFormat = updatedFormat + (' (+1)');
    }

    return updatedFormat;
  }

  const startTimeN = new Date(startTime).getTime();
  const endTimeN = isNightCharging ? new Date(bookingEndTime) : new Date(endTime).getTime();
  const total = endTimeN - startTimeN;

  let appendedArray = [];


  energyReport.forEach((report) => {
    if (Object.keys(report).length === 2 && report.startTime !== null && report.endTime !== null) {
      const reportStartTime = new Date(report.startTime).getTime();
      const reportEndTime = new Date(report.endTime).getTime();

      let reportStartPercentage = ((reportStartTime - startTimeN) / total) * 100;
      let reportEndPercentage = ((reportEndTime - startTimeN) / total) * 100;

      // Clamp values between 0 and 100
      reportStartPercentage = Math.max(0, Math.min(reportStartPercentage, 100));
      reportEndPercentage = Math.max(0, Math.min(reportEndPercentage, 100));
      appendedArray.push({ start: reportStartPercentage, end: reportEndPercentage, type: 'utilized', time: { start: (report.startTime), end: (report.endTime) } });
    }
  });


  let allEnergyReportHaveEnding = true;
  const updateProgress = () => {

    if (energyReport.length !== 0) {

      const lastEnergyReport = energyReport[energyReport.length - 1];
      if ((lastEnergyReport.startTime != null && lastEnergyReport.endTime === null)) {
        lastEnergyReport.endTime = new Date();

        const reportStartTime = new Date(lastEnergyReport.startTime).getTime();
        const reportEndTime = new Date(lastEnergyReport.endTime).getTime();

        let reportStartPercentage = ((reportStartTime - startTimeN) / total) * 100;
        let reportEndPercentage = ((reportEndTime - startTimeN) / total) * 100;

        // Clamp values between 0 and 100
        reportStartPercentage = Math.max(0, Math.min(reportStartPercentage, 100));
        reportEndPercentage = Math.max(0, Math.min(reportEndPercentage, 100));

        const newBooking = {
          start: reportStartPercentage,
          end: reportEndPercentage,
          type: 'utilized',
          time: { start: lastEnergyReport.startTime, end: lastEnergyReport.endTime },
          liveTime: true // Assuming this is where you want to check for liveTime existence
        };

        const index = appendedArray.findIndex(item => item.liveTime);
        if (index !== -1) {
          appendedArray[index] = newBooking; // Update existing liveTime entry
        } else {
          appendedArray.push(newBooking); // Push new entry
        }

        allEnergyReportHaveEnding = false;
        lastEnergyReport.endTime = null;
      }
    }

  }
  updateProgress();

  const updateProgressWithUnutilized = () => {

    // Fill the gaps with "unutilized" slots in a new array
    let newArray = [];
    let previousEnd = 0;
    let previousTimeEnd = new Date(startTime);
    appendedArray.forEach((report) => {
      if (report.start > previousEnd) {
        // Fill the gap with an "unutilized" slot
        const unutilizedTime = { start: (previousTimeEnd), end: (report.time.start) };
        newArray.push({ start: previousEnd, end: report.start, type: 'unutilized', time: unutilizedTime });
      }
      // Add the utilized slot
      newArray.push(report);
      previousEnd = report.end;
      previousTimeEnd = report.time.end
    });

    // Check for any gaps after the last report
    if (appendedArray.length > 0 && previousEnd < 100) {
      const unutilizedTime = { start: (previousTimeEnd), end: (new Date(isNightCharging ? bookingEndTime : endTime)) };
      newArray.push({ start: previousEnd, end: 100, type: 'unutilized', time: unutilizedTime });
    }

    return newArray;
  }

  updateProgress();
  let newArray = updateProgressWithUnutilized();

  useEffect(() => {
    updateProgress();
    newArray = updateProgressWithUnutilized();
  }, [currentTime, connectorStatus]);


  useEffect(() => {
    if (!allEnergyReportHaveEnding || connectorStatus === 'Charging') {
      setIsFinished(false);
    } else {
      const timeDifference = isNightCharging ? new Date(bookingEndTime).getTime() - currentTime.getTime() : endTimeWithGrace.getTime() - currentTime.getTime();
      if ((newArray.length && timeDifference <= gracePeriod * 60 * 1000)) {
        setIsFinished(true);
      } else {
        setIsFinished(false);
      }
    }
  }, [currentTime, allEnergyReportHaveEnding, connectorStatus, endTimeWithGrace]);


  useEffect(() => {
    if (isFinished) {
      const currentTimeInMillis = currentTime.getTime();
      const timeDifference = endTimeWithGrace - currentTimeInMillis;
      const gracePeriodInMillis = isNightCharging ? endTimeWithGrace - new Date(bookingEndTime).getTime() : gracePeriod * 60 * 1000; // 10 minutes in milliseconds
      const percentage = ((gracePeriodInMillis - timeDifference) / gracePeriodInMillis) * 100;
      setGracePeriodPercentage(percentage);
    }
  }, [currentTime, isFinished, endTimeWithGrace]);


  return (
<div>
    {isFinished && <span className={styles['booking-duration']}>{formattedStartTime} - {formattedEndTimeWithGrace}</span>}
    <div className={`${styles['progress-container']} ${isFinished ? styles['grace'] : ''}`}>
      <div className={styles['progress-container-left']}>
        <div className={styles['progress-time']}>
          <span>{formattedStartTime} - {formattedEndTime}</span>
          {/* <span>{formattedEndTime}</span> */}
        </div>

        <div className={`progress ${styles['progress']}`} >
          {
            newArray.length ? newArray.map((report, index) => (
              <Tooltip
                color={(report.liveTime === true ? '#52bb4b' : (report.type === 'unutilized' ? '#76787a' : '#18365E'))}
                placement="top"
                title={`${(report.type.charAt(0).toUpperCase() + report.type.slice(1))}  ${formatDate(new Date(report.time.start))} - ${formatDate(report.time.end)}`} key={index}
              >
                <div
                  className={(`progress-bar ${report.liveTime === true ? styles['progressbar-inprogress'] : styles['progressbar-' + report.type]}`)}
                  role="progressbar"
                  style={{ width: ((report.end - report.start)) + '%' }}
                  aria-valuenow={((report.end - report.start))}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                </div>
              </Tooltip>
            )) :

              <div className={`progress-bar ${styles['progressbar-unutilized']}`} aria-valuemin="0" aria-valuemax="100" aria-valuenow={100} style={{ width: '100%' }}>
                <p className={`card-text placeholder-glow`}><span className="placeholder col-12 rounded"></span> </p>
              </div>
          }
        </div>
      </div>

      <div className={styles['progress-container-right']}>
        <div className={`${styles['progress-time']} ${styles['one']}`}>
          <span className={styles['grace-show']}>{formattedEndTime}</span>
          <span className={styles['grace-show']}>Grace Period</span>
          <span>{formattedEndTimeWithGrace}</span>
        </div>

        <Tooltip
          color={('orange')}
          placement="top"
          title={newArray.length ? (`${('Grace Period')}  ${formatDate(new Date(isNightCharging ? bookingEndTime : endTime))} - ${formatDate(endTimeWithGrace)}`) : ''}
        >
          <div className={`progress ${styles['progress']}`} >
            {
              newArray.length ?
                <div
                  className={(`${styles['progressbar-gracePeriod']}`)}
                  role="progressbar"
                  style={{ width: ((gracePeriodPercentage)) + '%' }}
                  aria-valuenow={((gracePeriodPercentage))}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                </div>
                :
                <div className={`progress-bar ${styles['progressbar-unutilized']}`} aria-valuemin="0" aria-valuemax="100" aria-valuenow={100} style={{ width: '100%' }}>
                  <p className={`card-text placeholder-glow`}><span className="placeholder col-12 rounded"></span> </p>
                </div>
            }
          </div>
        </Tooltip>
      </div>

    </div>

</div>
  );
};

export default ProgressBar;